const pdfByOrderId = new Map<string, string>();

export function rememberShipLabelPdf(orderId: string, pdfBase64: string): void {
  const id = orderId.trim();
  const pdf = pdfBase64.trim();
  if (!id || !pdf) {
    return;
  }
  pdfByOrderId.set(id, pdf);
}

export function getRememberedShipLabelPdfs(orderIds: ReadonlyArray<string>): string[] {
  return orderIds
    .map((orderId) => pdfByOrderId.get(orderId))
    .filter((pdf): pdf is string => Boolean(pdf));
}

export function hasRememberedShipLabelPdf(orderIds: ReadonlyArray<string>): boolean {
  return orderIds.some((orderId) => pdfByOrderId.has(orderId));
}
